/*
  Peter Augustus homepage | Delivery postcode checker
  13 Oct 2026 | Theme 138814587088

  Answers from the store's delivery calculator, window.PAShipping
  (assets/pa-shipping-zones.js, the single source of truth). The section
  renders snippets/pa-shipping-calc.liquid, which defines PAShipping.ready()
  and downloads the calculator on the first call, so nothing loads until
  someone focuses the field.

  A serviced postcode reads as the Figma example: the area and its delivery
  days, "Queensland, delivery on Tuesday and Friday." Postcodes the
  calculator does not serve or does not know get the same wording as the
  store's delivery checker (assets/pa-delivery-checker.js).
*/
(() => {
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // One zone's region carries its days ("New South Wales Monday–Friday"); keep only the place
  function answer(result) {
    const area = result.zone.region.replace(/\s+(Monday|Tuesday|Wednesday|Thursday|Friday)\b.*$/, '') || result.zone.state;
    const days = result.zone.days.replace(/ & /g, ' and ');
    return `${area}, delivery ${/\bto\b/.test(days) ? '' : 'on '}${days}.`;
  }

  function bind(form) {
    if (form.dataset.dlBound) return;
    form.dataset.dlBound = 'true';
    const input = form.querySelector('[data-dl-input]');
    const block = form.closest('.pa-dl__checker');
    const out = block.querySelector('[data-dl-result]');
    const text = out.querySelector('[data-dl-text]');
    const contact = esc((window.PAShippingConfig && window.PAShippingConfig.contactUrl) || '/pages/contact');

    const show = (html, ok) => {
      text.innerHTML = html;
      out.classList.toggle('is-ok', ok);
      out.hidden = false;
    };

    // Start the calculator download as soon as someone heads for the field
    input.addEventListener('focus', () => window.PAShipping && window.PAShipping.ready(() => {}), { once: true });
    input.addEventListener('input', () => { input.value = input.value.replace(/\D/g, '').slice(0, 4); });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!window.PAShipping) return;
      window.PAShipping.ready((api) => {
        const check = api.checkPostcode(input.value);
        const pc = esc(check.postcode);
        if (check.status === 'serviced') show(esc(answer(check.result)), true);
        else if (check.status === 'not_serviced') show(`We do not deliver to ${pc} yet. <a href="${contact}">Contact us</a> and we will let you know if that changes.`, false);
        else if (check.status === 'unknown') show(`We could not match ${pc} to a delivery zone. Check the number, or <a href="${contact}">contact us</a> for a quote.`, false);
        else {
          show('Enter a 4 digit postcode.', false);
          input.focus();
        }
      });
    });
  }

  const scan = (root) => root.querySelectorAll('[data-dl-checker]').forEach(bind);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
})();
